import { LawyerConnection, Message, MessageType } from '@law-connect/types';

export const getRequestedUserInfo = (
  messages: Message[],
  connection: LawyerConnection
): boolean | null => {
  if (connection?.permissions?.userDetails || !messages) {
    return true;
  }
  // check if there is a message that is pending
  const permissionMessages =
    messages?.filter((m) => m.type === MessageType.Permission) ?? [];
  const pending = permissionMessages.find(
    (pm) =>
      pm.from === 'lawyer' &&
      !permissionMessages.find((m) => m?.content?.requestMessageId === pm.id)
  );
  return !!pending;
};
